export const Renderers = {
  pointRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      color: 'black',
      size: '3',
      outline: null,
    },
  },
  lineRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: 'blue',
      size: '3px',
      outline: null,
    },
  },
  rectangleRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: '#f0f0f0', //[51, 51, 204, 0.9],
      style: 'solid',
      outline: {
        color: 'black',
        width: 1,
      },
    },
  },
  contourRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: null,
      style: 'solid',
      outline: {
        color: [164, 121, 22],
        width: '1px',
      },
    },
  },
  tinRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: 'transparent',
      style: 'solid',
      outline: {
        color: [127, 127, 127, 255],
        width: '0.4',
      },
    },
  },
  contourLinesRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: 'blue',
      size: '3px',
      outline: null,
    },
  },
  boundaryRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: null,
      style: 'solid',
      outline: {
        color: 'blue',
        width: '1px',
      },
    },
  },
  syncPointRenderer: {
    type: 'simple-marker',
    symbol: {
      type: 'simple-marker',
      color: [255, 0, 0],
      outline: {
        color: [255, 255, 255],
        width: '1',
      },
      size: '7',
    },
  },
  /*** Design Elelments */
  alignmentPointRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      color: 'green',
      size: '5',
      outline: null,
      // style: 'triangle',
    },
  },
  alignmentCenterlineRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: 'blue',
      width: '2',
    },
  },
  alignmentStationOffsetLineRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: 'red',
      width: '1',
    },
  },
  alignmentStationLabelRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      color: 'transparent',
      size: '7',
      style:'circle',
      outline: null,
    },
  },
  profileGridLineRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: [10, 10, 10, 0.3],
      width: '0.5',
    },
  },
  profileLabelPointRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      color: [10, 10, 10, 0.3],
      size: '0.5',
      outline: null,
    },
  },
  reachStationPointRenderer: {
    type: 'simple',
    symbol: {
      type: 'simple-marker',
      color: 'black',
      size: '7',
      style:'circle',
      outline: null,
    },
  }
};
